"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JobAlertCriteria = (function () {
    function JobAlertCriteria() {
    }
    return JobAlertCriteria;
}());
exports.JobAlertCriteria = JobAlertCriteria;
var FilterType;
(function (FilterType) {
    FilterType[FilterType["Country"] = 1] = "Country";
    FilterType[FilterType["State"] = 2] = "State";
    FilterType[FilterType["City"] = 3] = "City";
    FilterType[FilterType["Distance"] = 4] = "Distance";
    FilterType[FilterType["DatePosted"] = 5] = "DatePosted";
    FilterType[FilterType["CustomFieldCheckbox"] = 6] = "CustomFieldCheckbox";
    FilterType[FilterType["CustomFieldDropdown"] = 7] = "CustomFieldDropdown";
    FilterType[FilterType["CustomFieldRadio"] = 8] = "CustomFieldRadio";
})(FilterType = exports.FilterType || (exports.FilterType = {}));
var CustomFieldItemType;
(function (CustomFieldItemType) {
    CustomFieldItemType[CustomFieldItemType["Dropdown"] = 3] = "Dropdown";
    CustomFieldItemType[CustomFieldItemType["Radiobutton"] = 5] = "Radiobutton";
    CustomFieldItemType[CustomFieldItemType["Checkbox"] = 7] = "Checkbox";
})(CustomFieldItemType = exports.CustomFieldItemType || (exports.CustomFieldItemType = {}));
var JobBoard;
(function (JobBoard) {
    JobBoard[JobBoard["IndeedATSSync"] = -19] = "IndeedATSSync";
    JobBoard[JobBoard["CandidateAPI"] = -18] = "CandidateAPI";
    JobBoard[JobBoard["InternalCareerSite"] = -17] = "InternalCareerSite";
    JobBoard[JobBoard["LinkedInRecruiterSystemConnect"] = -16] = "LinkedInRecruiterSystemConnect";
    JobBoard[JobBoard["TalentPool"] = -15] = "TalentPool";
    JobBoard[JobBoard["BroadbeanSearch"] = -14] = "BroadbeanSearch";
    JobBoard[JobBoard["InviteToApply"] = -13] = "InviteToApply";
    JobBoard[JobBoard["ExternalReferralLinkedIn"] = -12] = "ExternalReferralLinkedIn";
    JobBoard[JobBoard["ExternalReferralFacebook"] = -11] = "ExternalReferralFacebook";
    JobBoard[JobBoard["ExternalReferralEmail"] = -10] = "ExternalReferralEmail";
    JobBoard[JobBoard["ReferralSearchNetwork"] = -9] = "ReferralSearchNetwork";
    JobBoard[JobBoard["ReferralOther"] = -8] = "ReferralOther";
    JobBoard[JobBoard["ReferralSuggested"] = -7] = "ReferralSuggested";
    JobBoard[JobBoard["ReferralFacebook"] = -6] = "ReferralFacebook";
    JobBoard[JobBoard["ReferralLinkedIn"] = -5] = "ReferralLinkedIn";
    JobBoard[JobBoard["CandidateBank"] = -4] = "CandidateBank";
    JobBoard[JobBoard["AddedManually"] = -3] = "AddedManually";
    JobBoard[JobBoard["Referral_Email"] = -1] = "Referral_Email";
    JobBoard[JobBoard["CareerCenter"] = 1] = "CareerCenter";
})(JobBoard = exports.JobBoard || (exports.JobBoard = {}));



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/4d5b8a78b9bd1a6f/src/models/index.ts
// module id = 68
// module chunks = 0